import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { Button } from '@vimily/bonjoro-ui-components';

import '%/resources/assets/sass/Errors.scss';

import { assetUrl } from '~/helpers';

const Container = styled.div`
  ${({ fullPage }: { fullPage?: boolean }) => {
    if (fullPage) {
      return `
        position: absolute;
        top: 0;
        left: 0;
      `;
    }
  }}
`;

export interface CtaLinkProps {
  to: string;
  text: string;
}

export interface ErrorLayoutProps {
  httpCode: number;
  title: string;
  message?: string;
  errorCode?: string;
  ctaLink?: string;
  ctaText?: string;
  ctaLinkComponent?(props: CtaLinkProps): JSX.Element;
  children?: ReactNode;
  fullPage?: boolean;
  noFullPage?: boolean;
}

export function DefaultCtaLink({ to, text }: CtaLinkProps) {
  return (
    <a href={to}>
      <Button>{text}</Button>
    </a>
  );
}

export default function ErrorLayout({
  httpCode,
  errorCode,
  title,
  message,
  ctaLink = '/',
  ctaText = 'Return home',
  ctaLinkComponent = DefaultCtaLink,
  children,
  fullPage = true,
  noFullPage = false,
}: ErrorLayoutProps) {
  const CtaLink = ctaLinkComponent;

  return (
    <Container
      className='error-container'
      fullPage={noFullPage ? false : fullPage}
    >
      <div className='error-header'>
        <a href='/'>
          <img
            className='brand-bear'
            src={assetUrl('/assets/images/logos/logo_full.png')}
            width={145}
          />
        </a>
      </div>
      {children}

      <div className='error-http-code'>{httpCode}</div>
      {errorCode && <div className='error-code'>{errorCode}</div>}
      <div className='error-title'>{title}</div>
      <div className='error-message'>{message}</div>
      <CtaLink to={ctaLink} text={ctaText} />
    </Container>
  );
}
